// useQuickAdd.ts - Store Zustand para Quick Add Universal
// Bigwa v1.2 - Março 2026 — integrado com globalModalStore (SI auto-hide)

import { create } from 'zustand';
import { useGlobalModalStore } from '../stores/globalModalStore';
import { useImportQueueStore } from '../stores/importQueueStore';
import { bigwaToast } from '../utils/bigwaToast';

interface QuickAddState {
  isOpen: boolean;
  initialQuery: string;
  open: (query?: string) => void;
  close: () => void;
  toggle: () => void;
}

export const useQuickAdd = create<QuickAddState>((set) => ({
  isOpen: false,
  initialQuery: '',
  open: (query?: string) => {
    // Gate: bloquear abertura se importQueueStore está processando
    if (useImportQueueStore.getState().phase !== 'idle') {
      bigwaToast.info('Aguarde o processamento atual terminar.');
      return;
    }
    set({ isOpen: true, initialQuery: query || '' });
    useGlobalModalStore.getState().openGlobalModal('quick-add');
  },
  close: () => {
    set({ isOpen: false, initialQuery: '' });
    const store = useGlobalModalStore.getState();
    if (store.activeGlobalModal === 'quick-add') {
      store.closeGlobalModal();
    }
  },
  toggle: () => set((state) => {
    const newOpen = !state.isOpen;
    const modalStore = useGlobalModalStore.getState();
    if (newOpen) {
      modalStore.openGlobalModal('quick-add');
    } else if (modalStore.activeGlobalModal === 'quick-add') {
      modalStore.closeGlobalModal();
    }
    return { isOpen: newOpen };
  }),
}));

export default useQuickAdd;
